import React, { useEffect, useState } from "react";
import {
  AiOutlineSearch,
} from "react-icons/ai";
import {
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Typography,
  Input,
  Row,
  Col,
  Table,
  TablePaginationConfig,
  Tooltip,
  Dropdown,
  MenuProps,
  message,
} from "antd";
import Button from "../../components/Button";
import { useAuth } from "../../contexts/AuthContext";
import { IClient, useClients } from "../../contexts/ClientsContext";
import {
  Container,
  Content,
  DropdownButton,
} from "./styles";
import {
  isMobile,
  maskCpf,
} from "../../utils";
import { RiFileList3Line } from "react-icons/ri";
import { FaFileDownload } from "react-icons/fa";
import ReportsModal from "../../components/ReportsModal";
import { FiAlertTriangle } from "react-icons/fi";

var debounce: NodeJS.Timeout;

const tooltip: any = () => (
  <p
    style={{
      margin: "15px",
      fontSize: "13px",
      display: "flex",
      textAlign: "center",
    }}
  >
    O usuário já possui uma conta cadastrada na plataforma. Enviamos um e-mail
    solicitando a sua permissão de acesso à conta e estamos aguardando a
    confirmação do usuário.
  </p>
);

const initialData = {
  year: 2024
}

export const Reports: React.FC = () => {
  const { user } = useAuth();
  const {
    loadingGet,
    clients,
    getClients,
    totalClients,
  } = useClients();

  const [filters, setFilters] = useState<any>({ year: [initialData.year] });
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [clientSelected, setClientSelected] = useState<IClient>();
  const [typeReports, setTypeReports] = useState('');
  const [modalReportsOpen, setModalReportsOpen] =
    useState<boolean>(false);
  const [pagination] = useState<TablePaginationConfig>({
    current: currentPage,
    pageSize: 10,
    defaultPageSize: 10,
    showSizeChanger: false, // mudar para true quando o back estiver aceitando
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const handleDisabled = (item: any) => {
    const codes = (item.code || []).filter(
      (el: any) =>
        el?.escritorioId?.toString() === user?.user?.officeId?.toString() ||
        el?.assessorId?.toString() === user?.user?.assessorId?.toString()
    );
    return !codes.some((el: any) => !!el?.isAuthorized) || false;
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(() => {
      getClients({
        ...filters,
        searchText: value,
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    }, 1000);
  };

  const getPlan = (item: any) => {
    if (!item?.planActive) return (
      <Typography.Text style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <FiAlertTriangle size={14} />
        &nbsp;SEM PLANO
      </Typography.Text>
    )
    return (
      <>
        {'PLANO '}
        {item?.planName?.includes('_BASIC') ? 'BASIC ' : ''}
        {item?.planName?.includes('_CONCIERGE') ? 'CONCIERGE ' : ''}
        {item?.planName?.includes('_PRO') ? 'PREMIUM ' : ''}
        {item?.planName?.includes('ASSESSOR') ? 'ASSESSOR ' : ''}
        {(item.planType !== 'exterior')
          ? ((item?.planName?.includes('_MONTH') || item?.planType?.includes('mensal')) ? 'MENSAL' : 'ANUAL')
          : item.planName?.includes('ASSESSOR') ? ''
            : 'GRATUITO EXTERIOR'}
        {item.planType === "exterior"
          ? ""
          : item.hasPlanXp
            ? " (CLIENTE)"
            : " (ESCRITÓRIO)"}
      </>
    )
  }

  useEffect(() => {
    getClients();
  }, [getClients]);

  const Drop = (item: any, index: any, isDisabled: boolean) => {
    const items: MenuProps["items"] = [
      {
        key: 1,
        label: (
          <DropdownButton
            onClick={() => {
              if (item?.statusBolsa.includes('inativa')) 
                return message.info("Integração de bolsa inativa!");
              setTypeReports('bolsa');
              setClientSelected(item);
              setModalReportsOpen(true);
            }}
          >
            <RiFileList3Line />
            Relatórios de bolsa
          </DropdownButton>
        ),
      },
      {
        key: 2,
        label: (
          <DropdownButton
            onClick={() => {
              if (item?.statusExterior.includes('inativa')) 
                return message.info("Integração de exterior inativa!");
              setTypeReports('exterior');
              setClientSelected(item);
              setModalReportsOpen(true);
            }}
          >
            <RiFileList3Line />
            Relatórios de exterior
          </DropdownButton>
        ),
      },
    ];

    const unblockedReports = !!localStorage.getItem('show2024Report')

    if ((isDisabled || !item?.planActive) && !unblockedReports) {
      return (
        <div className="action-btns">
            <Button
              className="action-btn dots"
              disabled={isDisabled || !item?.planActive}>
              <FaFileDownload />
            </Button>
        </div>
      );
    }

    return (
      <div className="action-btns">
        <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
          <Button
            className="action-btn dots"
            disabled={isDisabled}>
            <FaFileDownload />
          </Button>
        </Dropdown>
      </div>
    );
  };

  return (
    <Container>
      <Content>
        <Row
          align="middle"
          gutter={[16, { xs: 16, sm: 32 }]}
          style={{ position: "relative" }}
        >
          <Col span={24}>
            <Typography.Title level={1} className="app-title">
              Relatórios (Bolsa e Exterior)
            </Typography.Title>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 16]} align="middle" justify="space-between">
              <Col {...(isMobile() ? { xs: 24 } : {})}>
              </Col>
              <Col>
                <Row gutter={[16, 16]} align="middle">
                  <Col {...(isMobile() ? { xs: 24 } : {})}>
                    <Input
                      size="large"
                      placeholder="Buscar cliente"
                      style={{ minWidth: "300px" }}
                      prefix={<AiOutlineSearch size={20} />}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Table
              rowKey="id"
              loading={loadingGet}
              dataSource={clients}
              pagination={{
                defaultPageSize: 10,
                total: totalClients,
                defaultCurrent: 1,
                simple: true,
                current: currentPage,
              }}
              onChange={(pagination, body, sorter) => {
                const order: any = sorter;
                setCurrentPage(pagination.current ?? 1);
                setFilters(filters);
                getClients({
                  searchText,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                  orderBy: order?.field || undefined,
                  orderDirection: order?.order || undefined,
                });
              }}
              locale={{
                filterReset: "Limpar",
              }}
              className="reports-table"
              style={{
                '--sidebar-color': '#01A2A4'
              } as React.CSSProperties}
              columns={[
                {
                  title: "Cliente",
                  sorter: (a, b) => a.name.localeCompare(b.name),
                  render: (_, item) => (
                    <>
                      <Row>
                        <Col
                          span={24}
                          style={{ color: "black", fontWeight: 500 }}
                        >
                          {item.name}
                        </Col>
                      </Row>
                      <Row>
                        <Col span={21} style={{ whiteSpace: "nowrap" }}>
                          {maskCpf(item.username)}
                        </Col>
                        {handleDisabled(item) && (
                          <Col span={1}>
                            <Tooltip title={tooltip}>
                              <InfoCircleOutlined />
                            </Tooltip>
                          </Col>
                        )}
                      </Row>
                    </>
                  ),
                },
                {
                  align: "center",
                  title: "E-mail",
                  dataIndex: "email",
                  sorter: (a: any, b: any) => a.email.localeCompare(b.email),
                  render: (email, record) => <div>{email}</div>,
                },
                {
                  align: "center",
                  title: "Plano",
                  dataIndex: "planName",
                  render: (_, record) => <div>{getPlan(record)}</div>,
                },
                {
                  align: "center",
                  title: "Integração bolsa",
                  dataIndex: "statusBolsa",
                  render: (statusBolsa, record) => <div>{statusBolsa}</div>,
                },
                {
                  align: "center",
                  title: "Integração exterior",
                  dataIndex: "statusExterior",
                  render: (statusExterior, record) => <div>{statusExterior}</div>,
                },
                {
                  title: "",
                  dataIndex: "orderBy",
                  render: (_, item, index) =>
                    Drop(
                      item,
                      index,
                      handleDisabled(item)
                    ),
                },
              ]}
            />
          </Col>
        </Row>
        <ReportsModal
          open={modalReportsOpen}
          type={typeReports}
          clientSelected={clientSelected}
          onCancel={() => { setModalReportsOpen(false); setTypeReports(''); }}
        />
      </Content>
    </Container>
  );
};
